import { trackAnalyticsCustomEvent } from '@ifixit/analytics';

// Analytics for the card in Guide/UI/templates/Document/fixbot_cta_card.phtml.
// Its form opens FixBot without this script.

const EVENT_CATEGORY = 'Document';
// The same first-view rule as the React FixBot cards' useTrackFirstView.
const VIEW_DWELL_MS = 200;

const card = document.querySelector('#documentFixbotCTA');
if (card) {
   trackFirstView(card);
   card
      .querySelector('form')
      ?.addEventListener('submit', () => track('Fixbot CTA - Input Submit', 'Fixbot CTA'));
}

function trackFirstView(element: Element) {
   let timer: ReturnType<typeof setTimeout> | undefined;
   const observer = new IntersectionObserver(entries => {
      if (!entries.at(-1)?.isIntersecting) {
         clearTimeout(timer);
         timer = undefined;
         return;
      }
      timer ??= setTimeout(() => {
         observer.disconnect();
         track('Fixbot CTA - Viewport Visible', 'teaser');
      }, VIEW_DWELL_MS);
   });
   observer.observe(element);
}

function track(eventAction: string, eventName: string) {
   trackAnalyticsCustomEvent({ eventCategory: EVENT_CATEGORY, eventAction, eventName });
}
